/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorExpertSlider as ResolvedLabradorExpertSlider } from 'base/components/labrador/ExpertSlider';

export const LabradorExpertSlider: typeof ResolvedLabradorExpertSlider = withLabradorInstanceof((props) => {
    return <ResolvedLabradorExpertSlider {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorExpertSliderProps = PropsFromComponent<typeof LabradorExpertSlider>;
